"use strict";
exports.__esModule = true;
exports.launchAmplifyCase = exports.launchAmplifyPopup = exports.caseDocumentsPopup = exports.bpmStepsPopup = exports.caseDetailPopup = void 0;
// most of these don't mean anything nowadays.
// browsers stopped supporting them a while ago
// really, the height and width are the meaningful ones.
var popupWindowFeatures = [
    "menubar=yes",
    "resizable=yes",
    "scrollbars=yes",
    "status=yes",
    "height=".concat(window.screen.height - 200),
    "width=600"
].join(',');
var caseDocsWindowFeatures = [
    "menubar=yes",
    "resizable=yes",
    "scrollbars=yes",
    "status=yes",
    "height=".concat(window.screen.height - 200),
    "width=1024"
].join(',');
exports.caseDetailPopup = {
    url: "/json-view/",
    windowFeatures: popupWindowFeatures,
    windowTitle: 'json-viewer'
};
exports.bpmStepsPopup = {
    url: "/bpm-steps/",
    windowFeatures: popupWindowFeatures,
    windowTitle: 'bpm-steps'
};
exports.caseDocumentsPopup = {
    url: "/case-documents/",
    windowFeatures: caseDocsWindowFeatures,
    windowTitle: 'case-documents'
};
exports.launchAmplifyPopup = {
    url: "/accelerate/",
    windowFeatures: '',
    windowTitle: 'amplify'
};
exports.launchAmplifyCase = {
    url: "/cmx/worklist/",
    windowFeatures: '',
    windowTitle: 'amplify'
};
//# sourceMappingURL=window-open-args.js.map